import { Component, computed, inject, signal } from '@angular/core';
import { InternalToolbar } from '../../components/internal-toolbar/internal-toolbar';
import { ReactiveIconTextButton } from '../../components/reactive-icon-text-button/reactive-icon-text-button';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TAGRequest } from '../../../models/tagrequest';
import { ApiService } from '../../api.service';
import { InputTextModule } from 'primeng/inputtext';
import { DatePipe } from '@angular/common';
import { RequestEditDialog } from './requestEditDialog';
import { DialogService } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { dialogConfig } from '../../dialogs';
import { MessageService } from 'primeng/api';
import { MatIcon } from '../../components/mat-icon/mat-icon';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { mapDateToSchoolyear } from '../../utils';

@Component({
  selector: 'app-internal-requests',
  imports: [
    InternalToolbar,
    ReactiveIconTextButton,
    TableModule,
    SkeletonModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    DatePipe,
    ButtonModule,
    TranslatePipe,
    MatIcon,
    SelectModule,
    FormsModule,
  ],
  providers: [DialogService, TranslateService],
  templateUrl: './internal-requests.html',
  styleUrl: './internal-requests.scss',
})
export class InternalRequests {
  private dialogService = inject(DialogService);
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);
  public api = inject(ApiService);

  loading = signal(true);
  allRequests = signal<TAGRequest[]>([]);

  allSchoolyears = computed(() => {
    let years = new Set<number>();
    for (let r of this.allRequests()) {
      years.add(mapDateToSchoolyear(r.startdate));
    }

    return Array.from(years.values()).sort((a, b) => b - a);
  });
  selectedSchoolyear = signal<number>(0);

  requests = computed(() => {
    if (this.loading()) {
      return Array.from({ length: 3 }).map((_, i) => new TAGRequest());
    }

    return this.allRequests().filter((r) =>
      mapDateToSchoolyear(r.startdate) == this.selectedSchoolyear()
    );
  });

  constructor() {}

  ngOnInit() {
    this.loadRequests();
  }

  loadRequests() {
    this.loading.set(true);

    this.api
      .getRequests()
      .then((requests: TAGRequest[]) => {
        let newRequests = requests.sort((a, b) => a.startdate.getTime() - b.startdate.getTime());

        this.allRequests.set(newRequests);
        if (this.selectedSchoolyear() == 0) {
          this.selectedSchoolyear.set(this.allSchoolyears()[0]);
        }

        this.loading.set(false);
      })
      .catch((reason) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.translate('errors.couldNotLoadRequests')(),
          detail: reason.message,
        });
      });
  }

  editRequest(request?: TAGRequest) {
    const dialogRef = this.dialogService.open(
      RequestEditDialog,
      dialogConfig<{ request: TAGRequest }>({
        data: {
          request: request,
        },
      }),
    );

    dialogRef.onClose.subscribe((result) => {
      console.log(result);
      if (result) {
        this.loadRequests();
      }
    });
  }
}
